import { ILoadableState } from "../definitions/ILoadableState";


const stateNeedsLoading = function (state: ILoadableState) {
    if (state.error) {
        return false;
    }
    return !state.isLoaded && !state.isLoading;
};

export { stateNeedsLoading };